import * as THREE from 'three';

/** Periodic value noise: the smoke sprite has transparent borders and cannot
 * tile across a wide bank. Two independent fields fit in one RG texture fetch.
 */
function fogNoise() {
  const size = 128, data = new Uint8Array(size * size * 2);
  for (let channel = 0; channel < 2; channel++) {
    const layers = [8, 16, 32].map((n, octave) => ({ n, weight: [0.6, 0.28, 0.12][octave],
      grid: Float32Array.from({ length: n * n }, (_, i) => {
        const value = Math.sin(i * 127.1 + octave * 311.7 + channel * 79.3 + 12.8) * 43758.5453;
        return value - Math.floor(value);
      }) }));
    for (let y = 0; y < size; y++) for (let x = 0; x < size; x++) {
      let value = 0;
      for (const { n, weight, grid } of layers) {
        const px = x / size * n, py = y / size * n, ix = Math.floor(px), iy = Math.floor(py);
        let u = px - ix, v = py - iy; u = u * u * (3 - 2 * u); v = v * v * (3 - 2 * v);
        const x1 = (ix + 1) % n, y1 = (iy + 1) % n;
        const a = grid[iy * n + ix] * (1 - u) + grid[iy * n + x1] * u;
        const b = grid[y1 * n + ix] * (1 - u) + grid[y1 * n + x1] * u;
        value += (a * (1 - v) + b * v) * weight;
      }
      data[(y * size + x) * 2 + channel] = Math.round(value * 255);
    }
  }
  const map = new THREE.DataTexture(data, size, size, THREE.RGFormat);
  map.wrapS = map.wrapT = THREE.RepeatWrapping;
  map.magFilter = map.minFilter = THREE.LinearFilter; map.needsUpdate = true;
  return map;
}

let shared: THREE.DataTexture | null = null;
/**
 * One shared tiling RG noise texture (two independent 3-octave fields, 8 cells per tile on the first
 * octave): the spawn fog, the floor's cloud shadows and the particles' fire/smoke read it instead of
 * hashing value noise per pixel.
 */
export function noiseTexture() { return (shared ??= fogNoise()); }
